module.exports = __webpack_public_path__ + "media/es_es_s1_Celesta.e12c0c00.mp3";